import {
  Button,
  FormControl,
  InputLabel,
  Select,
  Stack,
  TextField,
} from '@mui/material'
import {
  GridToolbarContainer,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro'
import { Clear } from '@mui/icons-material'
import { listFromCodes } from '../../../Functions/ListItemGenerator'
import { useUserContext } from '../../../Contexts/UserConfig'
import { stackGap } from '../../../Constants&Theme/Spacing'

export interface ScreenFilters {
  ScreenID: string
  RequestName: string
  BillingStatus: string[]
  SampleStatus: string[]
  Holdings: number[]
}
function ScreenManageDGToolbar({
  dgFilters,
  setDGFilters,
}: {
  dgFilters: ScreenFilters
  setDGFilters: any
}) {
  const { loginConfig, loadingConfig } = useUserContext()
  return (
    <GridToolbarContainer sx={{ width: 1, p: 1 }}>
      <Stack
        direction={'row'}
        gap={stackGap.row / 2}
        width={1}
        display={'flex'}
      >
        <GridToolbarDensitySelector />
        <TextField
          size="small"
          label={'Screen ID'}
          inputProps={{ 'aria-label': 'ScreenIDInput' }}
          sx={{ flex: 1 }}
          value={dgFilters?.ScreenID || ''}
          onChange={(e) =>
            setDGFilters((f: any) => {
              return { ...f, ScreenID: e.target.value }
            })
          }
        />
        <TextField
          size="small"
          label={'Request Name'}
          sx={{ flex: 2 }}
          value={dgFilters?.RequestName || ''}
          inputProps={{ 'aria-label': 'RequestNameInput' }}
          onChange={(e) =>
            setDGFilters((f: any) => {
              return { ...f, RequestName: e.target.value }
            })
          }
        />
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Billing Status</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'BillingStatusInput' }}
            label={'Billing Status'}
            value={dgFilters?.BillingStatus || []}
            multiple
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, BillingStatus: e.target.value }
              })
            }
          >
            {listFromCodes(loginConfig, 'ScreenBillingStatusID', loadingConfig)}
          </Select>
        </FormControl>
        <FormControl
          size="small"
          sx={{ flex: 1 }}
        >
          <InputLabel>Sample Status</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'SampleStatusInput' }}
            label={'Sample Status'}
            value={dgFilters?.SampleStatus || []}
            multiple
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, SampleStatus: e.target.value }
              })
            }
          >
            {listFromCodes(loginConfig, 'SampleStatusID', loadingConfig)}
          </Select>
        </FormControl>
        <FormControl
          size="small"
          sx={{ flex: 2 }}
        >
          <InputLabel>Holdings</InputLabel>
          <Select
            inputProps={{ 'aria-label': 'HoldingsInput' }}
            label={'Holdings'}
            value={dgFilters?.Holdings || []}
            multiple
            onChange={(e) =>
              setDGFilters((f: any) => {
                return { ...f, Holdings: e.target.value }
              })
            }
          >
            {listFromCodes(loginConfig, 'KV-Holdings', loadingConfig)}
          </Select>
        </FormControl>
        <Button
          variant={'outlined'}
          startIcon={<Clear />}
          color={'warning'}
          onClick={() => setDGFilters({})}
        >
          Clear Filters
        </Button>
      </Stack>
    </GridToolbarContainer>
  )
}

export default ScreenManageDGToolbar
